const sizes = {
  "carousel": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    letterSpacing: "-0.11px",
    padding: "12px 14px",
    m: "0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    border: "none",
    _hover: {
      backgroundColor: "#000000 !important",
      border: "none !important"
    },
  },
  "carousel-mobile": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "12px",
    letterSpacing: "-0.07px",
    padding: "8px 10px",
    m: "0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    border: "none",
    _hover: {
      border: "none !important",
    },
  },
  "carousel-festival": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    fontWeight: "bold",
    letterSpacing: "-0.11px",
    padding: "10px 12px",
    m: "0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    border: "none",
    _hover: {
      backgroundColor: "#000000 !important",
      border: "none !important",
    },
  },
  "2-card": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    letterSpacing: "-0.09px",
    padding: "12px 15px",
    m: "0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    border: "none",
    _hover: {
      border: "none !important",
    },
  },
  "2-card-mobile": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "10px",
    letterSpacing: "-0.06px",
    lineHeight: "10px",
    padding: "8px 10px",
    m: "0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    border: "none",
    _hover: {
      border: "none !important",
    },
  },
  "poster-slider": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "16px",
    letterSpacing: "-0.09px",
    padding: "12px 15px",
    m: "0",
    color: "white",
    borderRadius: "0",
    backgroundColor: "#DF3603",
    textTransform: "none",
    border: "none",
    _hover: {
      border: "none !important",
    },
  },
  "poster-slider-mobile": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "10px",
    letterSpacing: "-0.06px",
    lineHeight: "8px",
    padding: "8px 10px",
    m: "0",
    color: "white",
    borderRadius: "0",
    backgroundColor: "#DF3603",
    textTransform: "none",
    border: "none",
    _hover: {
      border: "none !important",
    },
  },
  "navbar-main": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "22px",
    letterSpacing: "0px",
    m: "0",
    p: "4px 0",
    color: "white",
    borderRadius: "0",
    textTransform: "none",
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    borderTopWidth: "0px !important",
    borderLeftWidth: "0px !important",
    borderRightWidth: "0px !important",
    _hover: {
      color: "#FFF !important",
      borderColor: "#FFF !important",
      borderStyle: "solid !important",
      backgroundColor: "transparent !important",
    },
    _focus: {
      outline: "none !important",
      borderColor: "#FFF !important",
      borderStyle: "solid !important"
    },
    _focusVisible:{
      boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    }
  },
  "navbar-subnav": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "700",
    fontSize: "20px",
    letterSpacing: "0px",
    w: "100%",
    m: "0 !important",
    padding: "16px 12px 16px 18px !important",
    color: "white !important",
    borderRadius: "0",
    textTransform: "none",
    backgroundColor: "transparent !important",
    border: "none !important",
    borderBottomWidth: "0px !important",
    borderTopWidth: "0px !important",
    borderLeftWidth: "0px !important",
    borderRightWidth: "0px !important",
    _hover: {
      backgroundColor: "white !important",
      color: "black !important",
      outline: "0 !important",
    },
    _focus: {
      outline: "0 !important",
      color: "black !important",
      backgroundColor: "white !important",
    },
    _active: {
      backgroundColor: "white !important",
      color: "black !important",
      outline: "0 !important",
    },
  },
  "navbar-desktop-icons": {
    m: "0",
    p: "0",
    color: "white !important",
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    borderBottomWidth: "0px !important",
    borderTopWidth: "0px !important",
    borderLeftWidth: "0px !important",
    borderRightWidth: "0px !important",
    _hover: {
      borderColor: "none !important",
      backgroundColor: "transparent !important",
      color: "white !important",
      outline: "none !important",
    },
    _focus: {
      outline: "none !important",
      borderColor: "#FFF !important",
      borderStyle: "solid !important"
    },
  },
}

const variants = {
  /* DLS */
  "primary": {
    color: "white",
    background: "transparent linear-gradient(90deg, #FF385C 0%, #BD1E59 100%) 0% 0% no-repeat padding-box;",
    _focus: {
      outline: "2px solid #BD1E59",
      border: "2px solid #FFF",
      textDecoration: "underline white",
    },
    _hover: {
      background: "transparent linear-gradient(270deg, #FF385C 0%, #BD1E59 100%) 0% 0% no-repeat padding-box;",
    },
    _active: {
      background: "#E3274E",
      transform: "scale(0.96)",
    }
  },
  "primary-inactive": {
    color: "stormtrooper.600",
    backgroundColor: "snowtrooper.100",
    pointerEvents: "none"
  },
  "secondary": {
    color: "white",
    backgroundColor: "stormtrooper.800",
    _focus: {
      outline: "2px solid #363636",
      border: "2px solid white",
      textDecoration: "underline white",
    },
    _hover: {
      backgroundColor: "stormtrooper.900",
    },
    _active: {
      backgroundColor: "stormtrooper.800",
      transform: "scale(0.96)"
    }
  },
  "secondary-inactive": {
    color: "stormtrooper.600",
    backgroundColor: "snowtrooper.100",
    pointerEvents: "none"
  },
  "tertiary": {
    color: "stormtrooper.900",
    backgroundColor: "white",
    border: "2px solid #747574",
    _focus: {
      border: "2px solid #1A1A1A",
      textDecoration: "underline #1A1A1A",
    },
    _hover: {
      backgroundColor: "ahsoka.500",
      border: "2px solid #1A1A1A",
    },
    _active: {
      backgroundColor: "ahsoka.300",
      border: "2px solid #747574",
      transform: "scale(0.96)"
    }
  },
  "tertiary-inactive": {
    color: "stormtrooper.300",
    border: "2px solid #949494",
    backgroundColor: "white",
    pointerEvents: "none"
  },
}

export const Button = {
  variants,
  sizes,
}
